import { App } from './App'
import { getServerSideProps } from './api'
export { App, getServerSideProps }
export default App
